import { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

export type SourceType =
  | 'thermal'
  | 'solar'
  | 'wind'
  | 'hydro'
  | 'biomass'
  | 'mixed'

export type BgConfig = {
  code: string
  name: string
  procurementType: string
  areaCode: AreaCode
  type: SourceType
  capacity: number
}

export const BG_LIST: readonly BgConfig[] = [
  {
    code: 'TH01',
    name: '東京火力第一',
    procurementType: '自社発電',
    areaCode: AreaCode.TOKYO,
    type: 'thermal',
    capacity: 3200,
  },
  {
    code: 'TH02',
    name: '中部火力センター',
    procurementType: '自社発電',
    areaCode: AreaCode.CHUBU,
    type: 'thermal',
    capacity: 2800,
  },
  {
    code: 'SO01',
    name: 'ソーラーファーム北関東',
    procurementType: '自社発電',
    areaCode: AreaCode.TOKYO,
    type: 'solar',
    capacity: 1200,
  },
  {
    code: 'WD01',
    name: 'ウインドパーク東北',
    procurementType: '自社発電',
    areaCode: AreaCode.TOHOKU,
    type: 'wind',
    capacity: 800,
  },
  {
    code: 'HY01',
    name: '奥多摩水力',
    procurementType: '自社発電',
    areaCode: AreaCode.TOKYO,
    type: 'hydro',
    capacity: 600,
  },
  {
    code: 'BM01',
    name: 'バイオマス千葉',
    procurementType: '自社発電',
    areaCode: AreaCode.TOKYO,
    type: 'biomass',
    capacity: 400,
  },
  {
    code: 'RT01',
    name: '相対A（火力）',
    procurementType: '相対調達',
    areaCode: AreaCode.KANSAI,
    type: 'thermal',
    capacity: 2500,
  },
  {
    code: 'RT02',
    name: '相対B（再エネ混合）',
    procurementType: '相対調達',
    areaCode: AreaCode.KYUSHU,
    type: 'mixed',
    capacity: 1800,
  },
  {
    code: 'RT03',
    name: '相対C（太陽光）',
    procurementType: '相対調達',
    areaCode: AreaCode.KYUSHU,
    type: 'solar',
    capacity: 900,
  },
  {
    code: 'HK01',
    name: '北海道火力',
    procurementType: '自社発電',
    areaCode: AreaCode.HOKKAIDO,
    type: 'thermal',
    capacity: 1500,
  },
  {
    code: 'HR01',
    name: '北陸水力',
    procurementType: '自社発電',
    areaCode: AreaCode.HOKURIKU,
    type: 'hydro',
    capacity: 700,
  },
  {
    code: 'CG01',
    name: '中国火力',
    procurementType: '相対調達',
    areaCode: AreaCode.CHUGOKU,
    type: 'thermal',
    capacity: 1200,
  },
  {
    code: 'SK01',
    name: '四国バイオ',
    procurementType: '相対調達',
    areaCode: AreaCode.SHIKOKU,
    type: 'biomass',
    capacity: 350,
  },
]

export const TYPE_I18N_KEYS: Record<string, string> = {
  thermal: 'page:balanceGeneration.filter.thermal',
  solar: 'page:balanceGeneration.filter.solar',
  wind: 'page:balanceGeneration.filter.wind',
  hydro: 'page:balanceGeneration.filter.hydro',
  biomass: 'page:balanceGeneration.filter.biomass',
  mixed: 'page:balanceGeneration.filter.mixed',
}
